//#region IMPORT
import React from 'react';
import { Unstable_Grid2 as Grid } from '@mui/material';
import { AuthButton, Dialog } from '../../../../Components/MUIs';
import { BusinessGridGridCommon } from '../../../../Components/BusinessGridGridCommon';
import {
  setStartDate,
  setEndDate,
  setSearchText,
} from '../../../../Reducer/SearchReducer';
import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { getColumnDefs1, getColumnDefs2 } from './AI_BASIC_ColumnDefs';
//#endregion

export default function AI_BASIC(props) {
  //#region 변수
  const dispatch = useDispatch();
  const searchInfo = useSelector((state) => state.SearchInfo);
  const userInfo = useSelector((state) => state.BaseInfo.userInfo);
  //#endregion
  //#region 웹(컬럼 세팅)
  const columnDefs1 = getColumnDefs1(props);
  const columnDefs2 = getColumnDefs2(props);
  //#endregion
  //#region 함수
  const autoGroupColumnDef2 = React.useMemo(() => {
    //그룹설정
    return {
      headerName: '일자',
      minWidth: 250,
    };
  }, []);
  //#endregion

  return (
    <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>
      <Grid xs={4} md={12}>
        <AuthButton
          menuId="Aicall"
          saveYn="Y"
          printYn="N"
          searchClick={(e) => {
            if (!props.validateSelection()) return;

            dispatch(setSearchText(e));
          }}
          saveClick={() => {
            if (!props.validateSelection()) return;

            props.SaveLogic1();
          }}
          conditions={[
            {
              type: 'datePicker',
              title: '기간',
              name: '조회일자(시작)',
              value: dayjs(searchInfo.startDate),
              onChange: (date) => {
                const newStart = dayjs(date).format('YYYY-MM-DD');
                const currentEnd = searchInfo.endDate;

                dispatch(setStartDate(newStart));

                // 시작일 >= 종료일이면 종료일도 시작일로 맞춤
                if (
                  currentEnd &&
                  !dayjs(newStart).isBefore(dayjs(currentEnd))
                ) {
                  dispatch(setEndDate(newStart));
                }

                props.Search2();
              },
              currentLocale: 'ko',
            },
            {
              type: 'datePicker',
              title: '기간',
              name: '조회일자(끝)', //기간
              value: dayjs(searchInfo.endDate),
              onChange: (date) => {
                const newEnd = dayjs(date).format('YYYY-MM-DD');
                const currentStart = searchInfo.startDate;

                // 종료일 < 시작일이면 시작일을 종료일로 맞춤
                if (
                  currentStart &&
                  dayjs(newEnd).isBefore(dayjs(currentStart))
                ) {
                  dispatch(setStartDate(newEnd));
                }

                dispatch(setEndDate(newEnd));
                props.Search2();
              },
              currentLocale: 'ko',
            },
            // ADMIN이면 추가 combo
            ...(userInfo.authCd === 'ADMIN'
              ? [
                  {
                    type: 'combo',
                    name: '회사',
                    items: searchInfo.coList,
                    value: searchInfo.coCd,
                    onChange: (e) => {
                      props.handleCoChange(e);
                      props.SearchLogic1();
                      props.Search2();
                    },
                  },
                ]
              : []),
            {
              type: 'combo',
              name: '사업장',
              items: searchInfo.custList,
              value: searchInfo.custCd,
              onChange: (e) => {
                props.handleCustChange(e);
                props.SearchLogic1();
                props.Search2();
              },
            },
          ]}
          grids={
            <BusinessGridGridCommon
              getRowId1={(params) => params.data.no}
              getRowId2={(params) => params.data.no}
              gridRef1={props.gridRef1}
              gridRef2={props.gridRef2}
              columnDefs1={columnDefs1}
              columnDefs2={columnDefs2}
              rowData1={props.rowData1}
              rowData2={props.rowData2}
              setSelectedRowData1={props.setSelectedRowData1}
              setSelectedRowData2={props.setSelectedRowData2}
              setChangedRowData1={props.setChangedRowData1}
              setChangedRowData2={props.setChangedRowData2}
              title1={'보이스 체크 내용'}
              title2={'보이스 체크 현황'}
              leftSize={35}
              rightSize={65}
              addYn1={'Y'}
              deleteYn1={'Y'}
              addYn2={'N'}
              deleteYn2={'N'}
              editable1={false}
              editable2={false}
              suppressCellFocus1={true}
              suppressCellFocus2={true}
              autoGroupColumnDef2={autoGroupColumnDef2}
              flex={1}
              addClick1={() => {
                if (!props.validateSelection()) return;

                props.HandleAddClick(props.gridRef1);
              }}
              refreshClick1={() => {
                if (!props.validateSelection()) return;

                props.SearchLogic1();
              }}
              refreshClick2={() => {
                if (!props.validateSelection()) return;

                props.Search2();
              }}
              deleteClick1={(e) => {
                if (!props.validateSelection()) return;

                const newRowExists = props.selectedRowData1.some(
                  (row) => row.newYn === 'Y'
                );

                if (!newRowExists) {
                  props.MarkedForDeletion1(props.selectedRowData1);
                } else {
                  props.NewYnErrorMsg();
                }
              }}
              onCellClicked1={(e) => {
                const gridApi = props.gridRef1.current.api;
                const clickedRowIndex = e.rowIndex;

                const isCheckboxClick = e.event?.target?.type === 'checkbox';

                if (!isCheckboxClick) {
                  gridApi.ensureIndexVisible(clickedRowIndex, 'middle');
                  gridApi.setFocusedCell(clickedRowIndex, 'reqNm');

                  const copied = JSON.parse(JSON.stringify(e.data));
                  props.handleRowSelection1(copied, clickedRowIndex);

                  gridApi
                    .getDisplayedRowAtIndex(clickedRowIndex)
                    ?.setSelected(true, false);
                }
              }}
              onSelectionChanged1={(gridRef) => {
                const gridApi = gridRef?.current?.api;
                if (!gridApi) return;
                const selectedNodes = gridApi.getSelectedNodes();
                const selectedData = selectedNodes.map((n) => n.data);
                props.selectedRowNosRef1.current = new Set(
                  selectedData.map((r) => r.no)
                );
                props.setSelectedRowData1(selectedData);
              }}
              onCellValueChanged1={(e) => {
                const key = e.data.no;

                props.setChangedRowData1?.((prev) => {
                  const filtered = prev.filter((row) => row.no !== key);
                  return [...filtered, { ...e.data }];
                });
              }}
              pagination1={false}
              rowDragManaged1={true}
              onRowDragEnd1={(e) => {
                let dragRowData = [];
                // 이전에 선택된 row의 키 저장
                const selectedKeys = new Set(
                  props.selectedRowData1.map((row) => row.no)
                );

                const gridApi = props.gridRef1?.current?.api;
                gridApi.forEachNode((node, index) => {
                  dragRowData.push({
                    ...node.data,
                    no: index + 1,
                    orgNo: node.data.no,
                  });
                });

                props.setRowData1(dragRowData);
                props.setChangedRowData1(dragRowData);

                // 선택 상태 복원 — orgNo가 이전에 선택된 키에 포함된 경우 선택
                props.selectedRowNosRef1.current = new Set(
                  dragRowData
                    .filter((item) => selectedKeys.has(item.orgNo))
                    .map((r) => r.no)
                );

                // 여기서 그리드 행 선택 상태를 직접 설정
                gridApi.forEachNode((node) => {
                  const shouldSelect = props.selectedRowNosRef1.current.has(
                    node.data.no
                  );
                  node.setSelected(shouldSelect, true); // 두번째 인자는 이벤트 발생 여부(false는 안 발생)
                });

                // 선택된 행 데이터 React 상태에 저장
                const selectedNodes = gridApi.getSelectedNodes();
                const selectedData = selectedNodes.map((n) => n.data);
                props.setSelectedRowData1(selectedData);
              }}
            />
          }
        />
      </Grid>
      {/* 그리드안 녹음 듣기 팝업 창 */}
      {props.modalToggle1 && (
        <Dialog
          title={'녹음 듣기'}
          open={props.modalToggle1}
          onClose={(e) => props.setModalToggle1(false)}
          contentSx={{
            display: 'flex',
            flexDirection: 'column',
          }}
          fullWidth
          saveButtonName={'선택'}
          closeButtonName={'닫기'}
          useSaveButton={false}
          useSaveAfterClose={true}
          maxWidth="sm"
          content={
            <div
              className="ag-theme-alpine no-scroll"
              style={{ width: '100%', height: '100%' }}
            >
              {props.voiceUrl ? (
                <audio controls>
                  <source src={props.voiceUrl} type="audio/mpeg" />
                  브라우저가 오디오 태그를 지원하지 않습니다.
                </audio>
              ) : (
                <p>Loading video...</p>
              )}
            </div>
          }
        />
      )}
    </Grid>
  );
}
